import { cva } from 'class-variance-authority';

const radioLabelBaseStyles = [
  'cursor-pointer',
  'disabled:cursor-not-allowed',
  'text-sm',
  'select-none',
];

const radioLabelStylesSAG = cva([
  ...radioLabelBaseStyles,
  'text-[#000028]',
  'peer-disabled:text-[#B3B3BE]',

  // Dark mode
  'dark:text-white',
  'dark:peer-disabled:text-[#737389]',
]);

const radioLabelStylesSHS = cva([
  ...radioLabelBaseStyles,
  'text-[#1A1A1A]',
  'peer-hover:text-[#1A1A1A]',
  'hover:text-[#1A1A1A]',
  'peer-checked:text-[#1A1A1A]',
  'peer-disabled:text-[#A3A3A3]',

  // Dark mode
  'dark:text-[#E6E6E6]',
  'dark:peer-hover:text-[#E6E6E6]',
  'dark:hover:text-[#E6E6E6]',
  'dark:peer-checked:text-[#E6E6E6]',
  'dark:peer-disabled:text-[#5C5C5C]',
]);

export { radioLabelStylesSAG, radioLabelStylesSHS };
